import type { Ref } from 'vue'
import type { PaginatedSearchResultList } from '@openapi'

export enum GlobalSearchResultType {
  User = 'user',
  Group = 'group',
  App = 'app',
  File = 'file',
}
export type GlobalSearchResult = {
  id: number
  picture_url: string
  headline: string
  name: string
  type: GlobalSearchResultType
  folder?: {
    name: string
    id: string
  }
}

export type GlobalSearchResponse = Omit<PaginatedSearchResultList, 'results'> & {
  results: GlobalSearchResult[]
}

export interface GlobalSearchContext {
  openSearch: (open?: boolean) => void
  resultTypes?: Ref<GlobalSearchResultType[]>
}
